module.exports = __webpack_public_path__ + "img/ssb_menu15.539e3d75.png";